import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import type { PaymentGatewatMaster, PaymentGatewatMasterList } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { Observable, catchError, map, throwError } from 'rxjs';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root'
})
export class PaymentGatewayMasterService {
  private http = inject(HttpClient);

  private BASE_URL: string = environment.BASE_URL;
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  createPaymentGateway(tenantId: number, data: any) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENT.CREATE_PAYMENT_GATEWAY
      .replace('{tenant_id}', tenantId.toString());
    return this.http
      .post(
        url,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  enablePayengine(tenantId: number, data: any) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENT.ENABLE_PAYENGINE
      .replace('{tenant_id}', tenantId.toString());
    return this.http
      .post(
        url,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  updatePaymentGateway(tenantId: number, id: number, data: any) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENT.UPDATE_PAYMENT_GATEWAY
      .replace('{tenant_id}', tenantId.toString())
      .replace('{gateway_id}', id.toString());
    return this.http
      .put(
        url,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getPaymentGatewayMasters(tenant_id: number): Observable<PaymentGatewatMasterList> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENT.GET_PAYMENT_GATEWAYS
      .replace('{tenant_id}', tenant_id.toString());
    return this.http.get(url, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getPaymentGatewayMasterById(tenantId: number,id:number) : Observable<PaymentGatewatMaster> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENT.GET_PAYMENT_GATEWAY_BY_ID
      .replace('{tenant_id}', tenantId.toString())
      .replace('{gateway_id}', id.toString());
    return this.http
      .get(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getPaymentGatewayMasterHMAC(tenantId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENT.GET_PAYMENT_GATEWAY_HMAC
      .replace('{tenant_id}', tenantId.toString());
    return this.http
      .get(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  updatePaymentGatewayStatus(tenantId: number, id: number, status: string): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENT.UPDATE_PAYMENT_GATEWAY_STATUS
      .replace('{tenant_id}', tenantId.toString())
      .replace('{gateway_id}', id.toString())
      .replace('{status}', status);
    return this.http
      .post(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  deletePaymentGateway(tenantId: number, id: number): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENT.DELETE_PAYMENT_GATEWAY
      .replace('{tenant_id}', tenantId.toString())
      .replace('{gateway_id}', id.toString());
    return this.http
      .delete(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
}
